import {Component} from 'preact';

export default class AbstractPage extends Component {
  constructor(props) {
    super(props);
    this.progress = this.props.progress;
    this._onNext = (this.props.onNext) ? this.props.onNext : function () {};
  }

  get screenData() {
    return this.props.data.steps.get(this.props.progress.current);
  }

  onNext(steps) {
    // window.scrollTo(0, 0);
    ('ga' in window) && ga('send', 'event', 'SpecialProject-rosatom', 'Rosatom_GoToStep', String(steps));
    this.progress.stepsToStack = steps;
    this.progress.goNext();
    this._onNext(steps);
  }

  componentDidUpdate() {
    if (this.screenData.endingScreen) {
      this.progress.startAgain();
    }
  }

  render() {
    return (<div>Я в процессе решения этой задачи</div>);
  }

  static backDataToModel(step) {
    const result = {};
    result.type = (step.type) ? step.type : null;
    result.specialClass = (step.specialClass) ? `content__step ${step.specialClass}` : `content__step`;
    result.comment = (step.comment) ? step.comment : null;
    result.title = (step.title) ? step.title : null;
    result.description = (step.description) ? step.description : null;
    result.endingScreen = (step.endingScreen) ? true : null;
    result.audioButtonSelector = (step.audioButtonSelector) ? step.audioButtonSelector : null;
    result.shareButton = (step.shareButton) ? step.shareButton : null;
    result.ref = (step.ref) ? step.ref : null;
    result.imageSrc = (step.imageSrc) ? step.imageSrc : null;
    result.shareButton = (step.shareButton) ? step.shareButton : null;

    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/abstract-page.js